exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes ghost-text{0%{background-position:-50px}40%{background-position:30vw}to{background-position:50vw}}", ""]);

// exports
